var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.addresses)?_c('div',{staticClass:"profile-container"},[_c('main-title',{staticClass:"mt10 mb16"},[_vm._v(_vm._s(_vm.$t('createOrder.title')))]),_c('div',{staticClass:"create-order-overlay"},[_c('create-form')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }